import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Coachee 360';

  constructor(private router: Router) {}

  ngOnInit(): void {
    initFlowbite();

    // Detect return from external payment gateway via query params or pathname
    const params = new URLSearchParams(window.location.search);
    const isFromPaymentGateway = params.has('external_id') ||
                                  params.has('status') ||
                                  params.has('payment_status') ||
                                  params.has('payment_id') ||
                                  params.has('transaction_id');
    const isRedirectToTransaction = window.location.pathname.includes('redirect-to-transaction');

    if (isFromPaymentGateway || isRedirectToTransaction) {
      const redirectUrl = window.location.origin + '/booking-success';
      window.location.replace(redirectUrl);
    }

    // Cleanup legacy sessionStorage flags
    sessionStorage.removeItem('pendingPayment');
    sessionStorage.removeItem('paymentReloaded');
  }
}
